import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import SweetAlert from 'sweetalert-react';
import withSizes from 'react-sizes';

import * as Utils from '../../utils/utils'
import * as Products from '../../utils/productHelpers';
import * as Cart from '../../utils/cartHelper'
import * as CartActions from '../../actions/cartActions'
import * as ProductsActions from '../../actions/productsActions';

import ProductCard from '../../components/commons/cards/ProductCard'
import QuantitySelector from '../../components/commons/quantity-selector/QuantitySelector'
import QuantitySelectorMobile from '../../components/commons/quantity-selector/QuantitySelectorMobile'
import SizeSelector from '../../components/commons/size-selector/SizeSelector'
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'
import Loader from '../../components/commons/loader/loader';
import SuggestionCard from '../../components/commons/cards/SuggestionCard';
import { gtagHelper } from '../../utils/gtagHelper'

class ProductDetailsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      minimumQuantity: 1,
      quantity: 1,
      isItemAddedToCart: false,
      showAlert: false,
      swalParams: {
        title: ""
      },
      productPrice: '',
      isOutside:false,
    }

    this.addressUpdated = this.addressUpdated.bind(this);
    this.getPriceOfProduct = this.getPriceOfProduct.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.onChangeProductQuantity = this.onChangeProductQuantity.bind(this);
    this.renderContentForDesktop = this.renderContentForDesktop.bind(this);
    this.renderContentForMobile = this.renderContentForMobile.bind(this);
    this.renderBundleDiscountInfo = this.renderBundleDiscountInfo.bind(this);
    this.addressUpdated = this.addressUpdated.bind(this);
    this.getAddressValidation = this.getAddressValidation.bind(this);
    this.updateVariantPriceBasedOnLocation = this.updateVariantPriceBasedOnLocation.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {location, match} = this.props;
    const productId = match && match.params
      ? match.params.productId
      : null;
    if (productId)
      this.props.dispatch(ProductsActions.getProductDetails(productId, response => {
        if(!response.status) {
          this.setState({
            showAlert: true,
            swalParams: {
              title: "Something went wrong, please try again later!",
              type: "error",
              showConfirmButton: false
            }
          });
        }

        if (response.status) {
          const { product, similar } = response.data;
          gtagHelper(product,similar);

    let storedAddressValidation = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
    // console.log("storedAddressValidation",storedAddressValidation);
    this.getPriceOfProduct(storedAddressValidation&&storedAddressValidation.region=='SHIPPO');
    window.addEventListener('address_changed', this.addressUpdated);
        }
      }));

    this.setState({
      isItemAddedToCart: !!Cart.isProductExist(productId)
    })
  }

  componentWillReceiveProps(newProps){
    const {location, match} = newProps;
    const productId = match && match.params
      ? match.params.productId
      : null;
      // console.log("CWRP",productId);
      // console.log("This props",this.props.match.params.productId);
    if (productId && productId != this.props.match.params.productId){
      // console.log("We get another productId in params");
      this.props.dispatch(ProductsActions.getProductDetails(productId, response => {
        if(!response.status) {
          this.setState({
            showAlert: true,
            swalParams: {
              title: "Something went wrong, please try again later!",
              type: "error",
              showConfirmButton: false
            }
          });
        }

        if (response.status) {
          const { product, similar } = response.data;
          // id is required
          gtagHelper(product, similar)
          let storedAddressValidation = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
          this.getPriceOfProduct(storedAddressValidation&&storedAddressValidation.region=='SHIPPO');
          window.addEventListener('address_changed', this.addressUpdated);
        }
      }));
      window.scrollTo(0, 0);
    }else{
      // console.log("Need not to dispatch product request as we get same productId");
    }
  }

  addressUpdated(e) {
   

    let storedAddressValidation = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
    this.getPriceOfProduct(storedAddressValidation&&storedAddressValidation.region=='SHIPPO');
  }

  getAddressValidation(){
    //currently cart is empty so use the set Delivery address
    let deliveryAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS);
    // console.log("1.deliveryAddress",deliveryAddress);
    const isDeliveryAddressSet=deliveryAddress?true:false;
    return isDeliveryAddressSet;
    }
    
  getPriceOfProduct(isOutside) {
    this.setState({isOutside:isOutside});
    // console.log("getPriceOfProduct(isOutside)",isOutside);
    const productDetals = Utils.toJS(this.props.productDetails);
    const data = productDetals ? productDetals.product : {};
    if (isOutside) {
      let outsideBoundaryPrice = data && data.Suggested ? data.Suggested.toFixed(2) : '';
      this.setState({ productPrice: outsideBoundaryPrice })
    } else {

      let insideBoundaryPrice = data && data.PriceB ? data.PriceB.toFixed(2) : ''
      this.setState({ productPrice: insideBoundaryPrice })
    }
  }
  updateVariantPriceBasedOnLocation(variant) {
    
    if (this.state.isOutside) {
      let outsideBoundaryVariantPrice = variant && variant.Suggested ? variant.Suggested.toFixed(2) : '';
      return outsideBoundaryVariantPrice;
    } else {

      let insideBoundaryVariantPrice = variant && variant.Price ? variant.Price.toFixed(2) : ''
      return insideBoundaryVariantPrice;
    }
  }

  render() {
    const {isMobile, loading} = this.props;
    const {showAlert, swalParams} = this.state;
    return (
      <div className={`page product-details-page ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          {!isMobile ? this.renderContentForDesktop() : this.renderContentForMobile()}
        </div>
        <Loader visibility={loading}/>
        <SweetAlert show={showAlert}
          customClass={"with-close"}
          showCancelButton
          cancelButtonText={"x"}
          {...swalParams}
          onCancel={()=> this.setState({showAlert:false})}
          onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }

  renderContentForDesktop() {

    const productDetals = Utils.toJS(this.props.productDetails);
    const product = productDetals ? productDetals.product : {};
    const variants = productDetals ? productDetals.variants : [];
    const discounts = productDetals && productDetals.product ? 
      productDetals.product.QuantityDiscount : [];
    const similarProducts = productDetals ? productDetals.similar : [];
    const {quantity, minimumQuantity} = this.state;

    const bundledDiscount = product ? product.QuantityDiscountOddItems 
      ? discounts.filter(d => d.quantity <= quantity) 
        ? discounts.filter(d => d.quantity <= quantity)[0] 
          : undefined
            : discounts.find(d => d.quantity === quantity)
              : undefined;
    console.log(bundledDiscount);
    return (
      <div>
        <div className="product-info-container">
          <div className="row">
            <div className="col-md-6">
              <div className="product-image-container">
                <img src={product && product.image
                  ? product.image
                  : ProductDefaultImage} className="product-image" onError={(e) => {
                  return e.target.src = ProductDefaultImage
                }}/>
              </div>
            </div>
            <div className="col-md-6 product-desc-container">
              <div className="info-header">
                <div className="content-left">
                  <div className="info-description">{product
                      ? (
                        <div>
                          <Link to={`/products?department=${encodeURIComponent(product.Department)}`}>{product.Department}</Link>
                          <span> / </span>
                        <Link to={`/products?category=${encodeURIComponent(product.Category)}`} >{product.Category}</Link>
                        </div>
                      ) : ''}</div>
                  <h1 className="info-title">{product && product.Description ? product.Description:''}</h1>
                </div>
                {this.getAddressValidation()?(<div className="content-right">
                {bundledDiscount ?
                    <div>
                    <h2 className="sale-original-price-text"><s>{product && product.PriceB
                        ? `$${this.state.productPrice}`
                        : ''}</s></h2>
                    <h2 className="sale-price-text">{bundledDiscount && bundledDiscount.priceB
                        ? `$${bundledDiscount.priceB.toFixed(2)}`
                        : ''}</h2>
                    </div>
                    : product && product.OnSale?
                      <div>
                      <h2 className="sale-original-price-text"><s>{product && product.PriceB
                          ? `$${this.state.productPrice}`
                          : ''}</s></h2>
                      <h2 className="sale-price-text">{product && product.SalePrice
                          ? `$${product.SalePrice.toFixed(2)}`
                          : ''}</h2>
                      </div>
                    : <h2 className="price-text">{product && product.PriceB
                    ? `$${this.state.productPrice}`
                    : ''}
                    </h2>
                }
                </div>):null}
              </div>
              <div className="info-body">
                {product && product["Sub Description 2"]
                  ? (
                    <div className="info-description sub-description">{product["Sub Description 2"]}</div>
                  )
                  : null}
                {product && product["Sub Description 3"]
                  ? (
                    <div className="info-description sub-description">{product["Sub Description 3"]}</div>
                  )
                  : null}
                {product && product["Item Lookup Code"]
                  ? (
                  <div className="info-description sku">#{product["Item Lookup Code"]}</div>
                  )
                  : null}
                {product && product["Ext'd Description"]
                  ? (
                    <div>
                      <div className="info-subtitle">Description</div>
                      <div className="info-description">{product["Ext'd Description"]}</div>
                    </div>
                  )
                  : null}
              </div>
              <div className="info-footer">
                { this.renderBundleDiscountInfo(discounts)
                }
                { (variants && variants.length > 1) &&
                  <div className="variants">
                    { variants.map(variant => {
                      return (
                        <Link to={`/products/${variant._id}`} >
                          <div className={`variant ${ variant._id === product._id ? 'active': '' }`} key={variant._id} >
                            <div className="size">{variant.Size}</div>
                            <div className="price">${variant._id === product._id?this.state.productPrice:this.updateVariantPriceBasedOnLocation(variant)}</div>
                          </div>
                        </Link>
                      );
                    }) }
                  </div>
                }

                <div className="info-subtitle">Quantity</div>
                <div className="quantity-selector-row">
                  <QuantitySelector quantity={quantity} onChangeQuantity={this.onChangeProductQuantity} minimumQuantity={minimumQuantity}/>
                {product && product['Size'] ? (
                  <SizeSelector selectedSize={product['Size']}/>
                ) : null}
                </div>
                {this.getAddressValidation()?
                <div className="button-add-to-bag" onClick={() => this.addToCart()}>Add to Bag</div>:
                <div className="button-add-to-bag" onClick={() => this.checkAvailiblityAlert()}>Check Availbilty</div>}
                <div className="info-subtitle">Share</div>
                <div className="social-links">
                  <a href={getTwitterShareUrl()} target="_blank"><i className="fa fa-twitter"/></a>
                <a href={getFacebookShareUrl()} target="_blank"><i className="fa fa-facebook"/></a>
                  {/* <a href="#"><i className="fa fa-instagram"/></a>
                  <a href="#"><i className="fa fa-yelp"/></a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="suggested-products-container">
          <h2 className="row-title">You May Also Like</h2>
          <div className="row">
            {similarProducts && similarProducts.map(product => {
              return (
                <div className="col-lg-2 col-md-3 product-card-container no-links" key={product._id}>
                  <SuggestionCard data={product} onSelectProduct={() => this.exploreProduct(product)} onAddToCart={() => this.addToCart(product)} noOutOfStock={true} 
                  checkAvailiblityAlert={() => this.checkAvailiblityAlert()} isDeliveryAddressSet={this.getAddressValidation()} isOutside={this.state.isOutside}/>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  renderContentForMobile() {
    const productDetals = Utils.toJS(this.props.productDetails);
    const product = productDetals ? productDetals.product : {};
    const variants = productDetals ? productDetals.variants : [];
    const discounts = productDetals && productDetals.product ? 
      productDetals.product.QuantityDiscount : [];
    const similarProducts = productDetals ? productDetals.similar : [];
    const {quantity, minimumQuantity} = this.state;

    const bundledDiscount = product ? product.QuantityDiscountOddItems 
      ? discounts.filter(d => d.quantity <= quantity) 
        ? discounts.filter(d => d.quantity <= quantity)[0] 
          : undefined
            : discounts.find(d => d.quantity === quantity)
              : undefined;

    return (
      <div>
        <div className="product-info-header">
          <div className="product-image-container">
            <img src={product && product.image
              ? product.image
              : ProductDefaultImage} className="product-image" onError={(e) => {
              return e.target.src = ProductDefaultImage
            }}/>
          </div>
          <div className="product-info">
            <div className="info-title">{product && product.Description ? product.Description:''}</div>
            <div className="info-description">{product && product.Category}</div>
            {product && product.OnSale?
              <div>
              <h2 className="sale-original-price-text"><s>{product && product.PriceB
                  ? `$${this.state.productPrice}`
                  : ''}</s></h2>
              <h2 className="sale-price-text">{product && product.SalePrice
                  ? `$${product.SalePrice.toFixed(2)}`
                  : ''}</h2>
              </div>
              : bundledDiscount ?
              <div>
              <h2 className="sale-original-price-text"><s>{product && product.PriceB
                  ? `$${this.state.productPrice}`
                  : ''}</s></h2>
              <h2 className="sale-price-text">{bundledDiscount && bundledDiscount.priceB
                  ? `$${bundledDiscount.priceB.toFixed(2)}`
                  : ''}</h2>
              </div>
              : <h2 className="price-text">{product && product.PriceB
              ? `$${this.state.productPrice}`
              : ''}
              </h2>
            }

            {product && product["Sub Description 2"]
              ? (
                <div className="info-description sub-description">{product["Sub Description 2"]}</div>
              )
              : null}
            {product && product["Sub Description 3"]
              ? (
                <div className="info-description sub-description">{product["Sub Description 3"]}</div>
              )
              : null}
            {product && product["Ext'd Description"]
              ? (<div className="info-description">{product["Ext'd Description"]}</div>)
              : null}
          </div>
        </div>
        { this.renderBundleDiscountInfo(discounts)
        }
        { (variants && variants.length > 1) &&
          <div className="variants">
            { variants.map(variant => {
              return (
                <Link to={`/products/${variant._id}`} >
                  <div className={`variant ${ variant._id === product._id ? 'active': '' }`} key={variant._id} >
                    <div className="size">{variant.Size}</div>
                    <div className="price">${variant._id === product._id?this.state.productPrice:this.updateVariantPriceBasedOnLocation(variant)}</div>
                  </div>
                </Link>
              );
            }) }
          </div>
        }
        <div className="product-info-footer">
          {product && product['Size'] ? (
            <SizeSelector selectedSize={product['Size']}/>
          ) : null}
          <QuantitySelectorMobile quantity={quantity} onChangeQuantity={this.onChangeProductQuantity} minimumQuantity={minimumQuantity}/>
        </div>
        <div className="button button-block button-blue add-to-cart-button" onClick={() => this.addToCart()}>Add to Bagy</div>
        <div className="suggested-products-container">
          <h2 className="section-header">You May Also Like</h2>
          <div className="row suggested-products">
            {similarProducts && similarProducts.map(product => {
              return (
                <div className="product-card-container no-links" key={product._id}>
                  <SuggestionCard data={product} onSelectProduct={() => this.exploreProduct(product)} onAddToCart={() => this.addToCart(product, true)} noOutOfStock={true} 
                  checkAvailiblityAlert={() => this.checkAvailiblityAlert()} isDeliveryAddressSet={this.getAddressValidation()}/>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  renderBundleDiscountInfo(discounts) {

    return (
      (discounts && discounts.length > 0)?
      <div className="discounts">
        <h5><span>Jason's Bundle Discount</span></h5>
        { discounts.map(d => {
          return (
            <span key={d.quantity} > Buy {d.quantity} at ${parseFloat(d.priceB).toFixed(2)} each! </span>
          );
        }) }
      </div>:null
    )
  }

  exploreProduct(product) {
    this.props.history.push(`/products/${product._id}`)
  }

  onChangeProductQuantity(newQuantity) {

    this.setState({ quantity: newQuantity });

  }

  addToCart(product) {

    const productDetals = Utils.toJS(this.props.productDetails);
    const { quantity } = this.state;
    product = product
      ? product
      : (productDetals
        ? productDetals.product
        : {});
    if (!product) {
      this.setState({
        showAlert: true,
        swalParams: {
          title: 'Something went wrong!',
          type: "error",
          showConfirmButton: false
        }
      })
      // setTimeout(() => this.setState({showAlert: false}), 1500);
      return;
    }
    Utils.addToCart(product, quantity ?  quantity : 1)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false,
          }
        })
        setTimeout(() => this.setState({ showAlert: false }), 1500);
       })
      .catch(err => {
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
      });
  }

  checkAvailiblityAlert() {
    this.setState({
      showAlert: true,
      swalParams: {
        title: "Address not selected",
        type: "error",
        showConfirmButton: false
      }
    });
    
}

}

function getFacebookShareUrl() {

  let pageUrl = window.location.href;
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(pageUrl)}`;
}

function getTwitterShareUrl() {

  let pageUrl = window.location.href;
  return `https://twitter.com/home?status=${encodeURI(pageUrl)}`;
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    productDetails: state.getIn(['products', 'recentProduct']),
    similarProducts: state.getIn(['products', 'similarProducts']),
    loading: state.getIn(['products', 'loading']),
    error: state.getIn(['products', 'error'])
  };
})(ProductDetailsPage));



// WEBPACK FOOTER //
// ./src/containers/products/ProductDetailsPage.js